<div class="card-basic mb-4" [ngClass]="{ 'card-has-focus': buttonIsFocused, 'has-error': hasProductsSelectedError() }">
  <ng-container *ngTemplateOutlet="content" />
</div>
<ng-template #content>
  <ng-container>
    <form [formGroup]="formGroup" tabindex="-1">
      <div class="card-basic-body">
        <div class="row align-items-center">
          <div class="col-auto text-center pt-4 productRow pl-xl-5 pr-xl-5 pb-lg-5 pb-3">
            <img src="/assets/icons/products/icon-{{ categoryIcon }}.png" alt width="75" />
            <h3 class="h6 f-16 mt-2 mb-0" data-test="product-category-text">{{ meterPoint().sparte | translateCategory }}</h3>
          </div>
          <div class="col">
            <ng-container>
              <div class="row">
                <div class="col-12 col-xl-6 pb-lg-5 pb-3">
                  <lib-ikp-info-input-read-only
                    id="readonlyMeterNumber"
                    [label]="'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterPointLabel'"
                    [value]="getZaehlpunktnummerShort(formGroup.get('meterPointNumber').value)"
                  />
                </div>
                <div class="col-12 col-xl-6 pb-lg-5 pb-3">
                  @if (!isMeterNumberEditable()) {
                    <lib-ikp-info-input-read-only
                      id="readonlyMeterNumber"
                      [label]="'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterNumberLabel'"
                      [value]="formGroup.get('meterNumber').value"
                    />
                    <a class="ikp-link fw-bold pointer ml-2" (click)="onEditMeterNumber()">
                      <i [class]="'fas fa-pencil mr-2'"></i>
                      <span>{{
                        'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterNumberCorrectionLink' | translate
                      }}</span>
                    </a>
                  } @else {
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="inputFieldRefName"
                        formControlName="meterNumber"
                        [ngClass]="{
                          'is-invalid': isInputInvalid(SELECTED_METER_POINTS_KEY + '.' + this.meterPoint().id + '.meterNumber'),
                        }"
                        [readonly]="!isMeterPointSelected()"
                      />
                      <label for="inputFieldRefName">{{
                        'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterNumberLabel' | translate
                      }}</label>
                      <div class="invalid-feedback">
                        {{ getFormError(SELECTED_METER_POINTS_KEY + '.' + this.meterPoint().id + '.meterNumber') | translate }}
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (isMeterNumberEditable()) {
                <div class="row pb-lg-5 pb-3">
                  <mwe-infobox
                    type="info"
                    titleKey="meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterNumberCorrectionInfoTitle"
                    messageKey="meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterNumberCorrectionInfoText"
                  />
                </div>
              }

              <div class="row">
                <div class="col-12 col-xl-6 order-lg-0 order-1 pb-lg-5 pb-3">
                  <div class="form-floating">
                    <input
                      type="text"
                      inputmode="decimal"
                      class="form-control"
                      id="inputFieldZaehlerstand"
                      placeholder="{{
                        'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterCountPlaceholder' | translate
                      }}"
                      formControlName="meterCount"
                      [ngClass]="{ 'is-invalid': isInputInvalid(SELECTED_METER_POINTS_KEY + '.' + this.meterPoint().id + '.meterCount') }"
                      [readonly]="!isMeterPointSelected()"
                    />
                    <label for="inputFieldZaehlerstand">{{
                      'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterCountLabel' | translate
                    }}</label>
                    <div class="invalid-feedback">
                      {{ getFormError(SELECTED_METER_POINTS_KEY + '.' + this.meterPoint().id + '.meterCount') | translate }}
                    </div>
                    <div class="text-muted mt-1">
                      <i class="fas fa-info-circle"></i>
                      {{ 'meterPoint.meterPointChangeRequest.productAndDateStep.productSelection.meterCountInfo' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</ng-template>
